import React, { useState, useEffect } from 'react'
import { Row, Select, Col, Spin } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import { sendEmailForExpressPolicyChanges } from '../services'

import AddVehicleStyle from '../../styles/AddVehicle.module.css'
const antIcon = <LoadingOutlined spin style={{ fontSize: 48 }} />

import {
  VEHICLE_COLLISION_DEDUCTIBLE_NJ,
  VEHICLE_MILEGE,
  VEHICLE_USAGE,
  VEHICLE_DAYS_DRIVE_MILES,
  VEHICLE_COLLISION_DEDUCTIBLE_PA,
  VEHICLE_COLLISION_DEDUCTIBLE,
  VEHICLE_COLLISION_NJ,
  VEHICLE_COLLISION_MI,
  VEHICLE_COLLISION_PA,
  VEHICLE_OWNERSHIP,
  VEHICLE_DAYS_USAGE,
  STATE,
  ADD_VEHICLE_MI_JSON_MAP,
  ADD_VEHICLE_PA_JSON_MAP,
  ADD_VEHICLE_NJ_JSON_MAP
} from './AddVehicleConstants'
import AddVehicleMI from './AddVehicleMI'
import AddVehicleNJ from './AddVehicleNJ'
import AddVehiclePA from './AddVehiclePA'
import {
  validateMIFields,
  validatePAFields,
  validateNJFields,
  stripMIFinalJson,
  stripNJFinalJson,
  stripPAFinalJson
} from './AddVehicleValidators'
import { LoadingOutlined } from '@ant-design/icons'

const { Option } = Select

const AddVehicle = () => {
  const [selectedState, setSelectedState] = useState(null)
  const [miVehicle, setMIVehicle] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    zipCode: '',
    emailAddress: '',
    vehicleInfo: {
      vin: '',
      year: '',
      make: '',
      model: '',
      purchaseDate: '',
      stateRegistered: '',
      registeredPersonFirstName: '',
      registeredPersonLastName: '',
      vehicleUsage: null,
      nameOfBank: '',
      annualMileage: null,
      vehicleOwnership: null,
      isVehicleWithCoOwnership: '',
      coOwnershipPersonFirstName: '',
      coOwnershipPersonLastName: '',
      otherCollisionCoverage: '',
      otherCollisionDeductible: null,
      collisionCoverage: null,
      collisionType: null,
      collisionCoverageDeductible: null,
      rentalReimbursement: '',
      isVehiclePrimarilyKeptOvernight: '',
      overnightVehicleAddress: {
        streetAddress: '',
        apt: '',
        city: '',
        state: '',
        zipCode: ''
      }
    },
    isBusinessPurpose: '',
    reason: '',
    effectDate: ''
  })
  const [paVehicle, setPAVehicle] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    zipCode: '',
    emailAddress: '',
    vehicleInfo: {
      vin: '',
      year: '',
      make: '',
      model: '',
      purchaseDate: '',
      stateRegistered: '',
      registeredPersonFirstName: '',
      registeredPersonLastName: '',
      noOfDaysUsed: null,
      oneWayMiles: null,
      vehicleOwnership: null,
      nameOfBank: '',
      isVehicleWithCoOwnership: '',
      coOwnershipPersonFirstName: '',
      coOwnershipPersonLastName: '',
      otherCollisionCoverage: '',
      otherCollisionDeductible: null,
      collisionCoverage: '',
      collisionCoverageDeductible: null,
      rentalReimbursementCoverage: '',
      isVehiclePrimarilyKeptOvernight: '',
      overnightVehicleAddress: {
        streetAddress: '',
        apt: '',
        city: '',
        state: '',
        zipCode: ''
      }
    },
    isBusinessPurpose: '',
    reason: '',
    effectDate: ''
  })
  const [njVehicle, setNJVehicle] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    zipCode: '',
    emailAddress: '',
    vehicleInfo: {
      vin: '',
      year: '',
      make: '',
      model: '',
      purchaseDate: '',
      stateRegistered: '',
      registeredPersonFirstName: '',
      registeredPersonLastName: '',
      noOfDaysUsed: null,
      oneWayMiles: null,
      vehicleOwnership: null,
      nameOfBank: '',
      isVehicleWithCoOwnership: '',
      coOwnershipPersonFirstName: '',
      coOwnershipPersonLastName: '',
      otherCollisionCoverage: '',
      otherCollisionDeductible: null,
      collisionCoverage: '',
      collisionCoverageDeductible: null,
      rentalReimbursementCoverage: '',
      isVehiclePrimarilyKeptOvernight: '',
      overnightVehicleAddress: {
        streetAddress: '',
        apt: '',
        city: '',
        state: '',
        zipCode: ''
      }
    },
    isBusinessPurpose: '',
    reason: '',
    effectDate: ''
  })
  const [disableNJButton, setDisableNJButton] = useState(false)
  const [disablePAButton, setDisablePAButton] = useState(false)
  const [disableMIButton, setDisableMIButton] = useState(false)
  const [spinner, setSpinner] = useState(true)

  useEffect(() => {
    window.location = "https://www.cure.com/g/express-policy-changes";
  }, [])

  const buildTable = (vehicleInfo, map) => {
    var table = '<table border="1">'
    table += '<tr><td colspan="2"><b>Policyholder Information</b></td></tr>'
    for (const key in vehicleInfo) {
      if (vehicleInfo[key] instanceof Object) {
        table += '<tr><td colspan="2"><b>Vehicle Information</b></td></tr>'
        for (const additionalKey in vehicleInfo[key]) {
          const value = vehicleInfo[key][additionalKey]
          if (vehicleInfo[key][additionalKey] instanceof Object) {
            table += '<tr><td colspan="2"><b>Address of vehicles kept overnight</b></td></tr>'
            for (const addressKey in vehicleInfo[key][additionalKey]) {
              table += `<tr><td>${map[key][additionalKey][addressKey]}</td><td>${
                vehicleInfo[key][additionalKey][addressKey] || ''
              }</td></tr>`
            }
          } else {
            if (vehicleInfo[key][additionalKey] === 'noOfDaysUsed') {
              const [filteredValue] = VEHICLE_DAYS_USAGE.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else if (vehicleInfo[key][additionalKey] === 'vehicleOwnership') {
              const [filteredValue] = VEHICLE_OWNERSHIP.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else if (vehicleInfo[key][additionalKey] === 'otherCollisionDeductible') {
              const arr =
                selectedState === 'NJ'
                  ? VEHICLE_COLLISION_NJ
                  : selectedState === 'MI'
                  ? VEHICLE_COLLISION_MI
                  : VEHICLE_COLLISION_PA
              const [filteredValue] = arr.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else if (vehicleInfo[key][additionalKey] === 'collisionCoverageDeductible') {
              const arr =
                selectedState === 'NJ'
                  ? VEHICLE_COLLISION_DEDUCTIBLE_NJ
                  : selectedState === 'MI'
                  ? VEHICLE_COLLISION_DEDUCTIBLE
                  : VEHICLE_COLLISION_DEDUCTIBLE_PA
              const [filteredValue] = arr.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else if (vehicleInfo[key][additionalKey] === 'oneWayMiles') {
              const [filteredValue] = VEHICLE_DAYS_DRIVE_MILES.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else if (vehicleInfo[key][additionalKey] === 'vehicleUsage') {
              const [filteredValue] = VEHICLE_USAGE.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else if (vehicleInfo[key][additionalKey] === 'annualMileage') {
              const [filteredValue] = VEHICLE_MILEGE.filter(item => item.id === value) ?? [{ label: '' }]
              table += `<tr><td>${map[key][additionalKey]}</td><td>${filteredValue.label || ''}</td></tr>`
            } else {
              table += `<tr><td>${map[key][additionalKey]}</td><td>${vehicleInfo[key][additionalKey] || ''}</td></tr>`
            }
          }
        }
      } else {
        table += `<tr><td>${map[key]}</td><td>${vehicleInfo[key] || ''}</td></tr>`
      }
    }
    table += '</table>'
    return table
  }

  const handleSubmit = async () => {
    const json =
      selectedState === 'NJ'
        ? ADD_VEHICLE_NJ_JSON_MAP
        : selectedState === 'MI'
        ? ADD_VEHICLE_MI_JSON_MAP
        : ADD_VEHICLE_PA_JSON_MAP

    if (selectedState === 'NJ') {
      setDisableNJButton(true)
    } else if (selectedState === 'MI') {
      setDisableMIButton(true)
    } else {
      setDisablePAButton(true)
    }

    const stateData = selectedState === 'NJ' ? njVehicle : selectedState === 'MI' ? miVehicle : paVehicle

    const finalJson =
      selectedState === 'NJ'
        ? stripNJFinalJson(stateData)
        : selectedState === 'MI'
        ? stripMIFinalJson(stateData)
        : stripPAFinalJson(stateData)
    const htmlText = buildTable(finalJson, json)
    const mailObj = {
      subject: `[Add Vehicle] - ${selectedState}- ${finalJson.policyNumber}`,
      content: htmlText
    }
    localStorage.setItem('expressPolicyChangeType', 'Add Vehicle')

    await sendEmailForExpressPolicyChanges(mailObj)

    const newWindow = window.open('/g/express-policy-changes/result', '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const handleMIState = state => {
    setMIVehicle({
      ...state
    })
  }

  const handlePAState = state => {
    setPAVehicle({
      ...state
    })
  }

  const handleNJState = state => {
    setNJVehicle({
      ...state
    })
  }

  const miButtonStatus = !validateMIFields(miVehicle) || disableMIButton
  const paButtonStatus = !validatePAFields(paVehicle) || disablePAButton
  const njButtonStatus = !validateNJFields(njVehicle) || disableNJButton

  return (
    <div className="container">
      <GlobalHeader />

      {spinner ?
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Spin indicator={antIcon} />
        </div>
      :
        <>
          {!selectedState && (
            <>
              <EmptyHeaderHero minHeight={true} title="Add Vehicle" />
              <Row className={`${AddVehicleStyle["state-selection"]}`}>
                <div className={`${AddVehicleStyle["add-vehicle-state"]}`}>
                  <Col xl={{ span: 11 }} xs={{ span: 24 }}>
                    <h5 className={`${AddVehicleStyle["sub-label"]}`}>Please select your state:</h5>
                  </Col>
                  <Col xl={{ span: 6 }} xs={{ span: 24 }}>
                    <Select
                      onChange={event => setSelectedState(event)}
                      placeholder="Select state"
                      value={selectedState || undefined}
                    >
                      {STATE.map((obj, index) => (
                        <Option key={index} value={obj.id}>
                          {obj.label}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </div>
              </Row>
            </>
          )}
          {selectedState === 'MI' && (
            <>
              <AddVehicleMI
                handleSubmit={handleSubmit}
                miVehicle={miVehicle}
                setMIVehicle={handleMIState}
                validate={miButtonStatus}
              />
            </>
          )}
          {selectedState === 'NJ' && (
            <>
              <AddVehicleNJ
                handleSubmit={handleSubmit}
                njVehicle={njVehicle}
                setNJVehicle={handleNJState}
                validate={njButtonStatus}
              />
            </>
          )}
          {selectedState === 'PA' && (
            <>
              <AddVehiclePA
                handleSubmit={handleSubmit}
                paVehicle={paVehicle}
                setPAVehicle={handlePAState}
                validate={paButtonStatus}
              />
            </>
          )}
        </>
      }
      <GlobalFooter />
    </div>
  )
}

AddVehicle.propTypes = {}

export default AddVehicle
